import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import { apiClient } from '@config/server/apiClient';
import { productOnboardingEndpoints } from '@config/server/apiEndpoints';

interface ProvisionOnboardingResult {
	inviteUrl: string;
	servicesProviderId: string;
	alreadyProvisioned?: boolean;
}

export const useProvisionOnboarding = (): UseMutationResult<ProvisionOnboardingResult, unknown, string> =>
	useMutation({
		mutationFn: async (onboardingRecordId: string) => {
			// Provision creates SVP, Firebase Auth, Group, Membership, Invitation —
			// this can take longer than the default 15s timeout.
			const res = await apiClient.post<ProvisionOnboardingResult>(
				productOnboardingEndpoints.provision(onboardingRecordId),
				undefined,
				{ timeout: 60_000 },
			);
			return res.data as ProvisionOnboardingResult;
		},
	});
